import { type CSSProperties } from 'react';
import './StageTrigger.css';

interface StageTriggerProps {
  label: string;
  onClick: () => void;
  /** Distance from the left edge of the stage in px. The triggers sit
   *  on a single row at top:12; consumers space themselves manually. */
  offsetLeft: number;
  ariaLabel?: string;
  /** Highlight the button — used by the TUNER trigger to indicate the
   *  tuner view is currently open (acts as a toggle). */
  active?: boolean;
}

/**
 * Floating uppercase pill button on the camera stage. The 3 trigger
 * buttons (TUNING / SYNTH / TUNER) are visually identical — same dark
 * pill, same letter-spacing, same hover treatment. Only the label and
 * x-offset differ, so they all compose this template.
 *
 * The 4th trigger (Settings gear icon, top-right) renders an SVG and
 * keeps its own component.
 */
export function StageTrigger({
  label,
  onClick,
  offsetLeft,
  ariaLabel,
  active,
}: StageTriggerProps) {
  const style: CSSProperties = { left: `${offsetLeft}px` };
  return (
    <button
      type="button"
      className={'stage-trigger' + (active ? ' stage-trigger--active' : '')}
      style={style}
      onClick={onClick}
      aria-label={ariaLabel ?? `Open ${label.toLowerCase()}`}
      aria-pressed={active ? true : undefined}
    >
      {label}
    </button>
  );
}
